



























































































































































































import { PropType } from 'vue';

import mixins from '@/utils/mixins';
import Validatable from '@/mixins/validatable';
import BindsAttrs from '@/mixins/binds-attrs';

import { QuoteExtraItem } from '@/models/quote';
import { ErrorHandler } from '@/models/errors';
import QuillPDFEditor from '../common/QuillPDFEditor.vue';

const baseMixins = mixins(BindsAttrs, Validatable);

interface Options extends InstanceType<typeof baseMixins> {
  /* eslint-disable-next-line camelcase */
  $_modelEvent: string;
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'QuotesExtraItemsSection',

    components: { QuillPDFEditor },

    props: {
      editable: Boolean,
      exchangeRate: Number,
      currencyCode: String,

      errors: {
        type: Object as PropType<ErrorHandler>
      }
    },

    watch: {
      internalValue: {
        handler() {
          this.validate();
        },
        deep: true
      }
    },

    computed: {
      requiredRule() {
        return (field: string) => [
          (v: string) => !!v || `${field} is required`
        ];
      }
    },

    methods: {
      removeExtraItem(item: QuoteExtraItem, index?: number) {
        const itemIndex = index ?? this.internalValue.indexOf(item);
        this.internalValue.splice(itemIndex, 1);
      },

      addExtraItem() {
        this.internalValue.push(new QuoteExtraItem());
      }
    }
  });
